import React, { useState } from "react";
import styles from "./UserProfile.module.css";
import { useGetProfileDdetailQuery } from "../../store/api/profileApi";
import {
  Briefcase,
  Phone,
  Mail,
  Globe,
  MapPin,
  Home,
  Flag,
  Award,
  FileText,
  Hash,
  CreditCard,
} from "react-feather";
import Loader from "../../components/common/Loader";
import ModalPopup from "../../components/ModelPopup";
import { FaEye } from "react-icons/fa6";
import FilePreviewer from "../../components/FilePreviewer";

const UserDetails = ({ profileData, loadingProfileData }) => {
  const [previewFile, setPreviewFile] = useState({
    key: "",
    url: "",
  });
  return (
    <div>
      {" "}
      {loadingProfileData && <Loader />}
      <div className={styles.accountDetailRoot}>
        <div className={styles.businessDetailContainer}>
          {/* Row 1: Business Name, Phone, Email , Website*/}
          <div className={styles.colGroup}>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Briefcase />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Business Name</span>
                <div className={styles.infoValue}>
                  {profileData?.business_name}
                </div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Phone />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Phone</span>
                <div className={styles.infoValue}>{profileData?.phone}</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Mail />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Email</span>
                <div className={styles.infoValue}>{profileData?.email}</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Globe />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Website</span>
                <div className={styles.infoValue}>
                  <a
                    href={profileData?.website_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.portalUrl}
                  >
                    {profileData?.website_url}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.horizontalDivider} />
          {/* Row 2: Address only */}
          <div className={styles.colGroup}>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <MapPin />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Address</span>
                <div className={styles.infoValue}>
                  {`${profileData?.address}, ${profileData?.secondary_address} ${profileData?.building_name}`}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.horizontalDivider} />
          {/* Row 3: City, State/Province, Country, Postal Code */}
          <div className={styles.colGroup}>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Home />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>City</span>
                <div className={styles.infoValue}>{profileData?.city}</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <MapPin />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>State/Province</span>
                <div className={styles.infoValue}>{profileData?.state}</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Flag />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Country</span>
                <div className={styles.infoValue}>{profileData?.country}</div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Mail />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Postal Code</span>
                <div className={styles.infoValue}>
                  {profileData?.postal_code}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.horizontalDivider} />
          {/* Row 4: Resale Certificate Number, Government License Number, Tax Identification Number */}
          <div className={styles.colGroup}>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Award />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>
                  Resale Certificate Number
                </span>
                <div className={styles.infoValue}>
                  {profileData?.resale_certificate_number}
                </div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <CreditCard />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>
                  Government License Number
                </span>
                <div className={styles.infoValue}>
                  {profileData?.gov_license_number}
                </div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <Hash />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>
                  Tax Identification Number / CRA GST Number
                </span>
                <div className={styles.infoValue}>
                  {profileData?.tin_gst_number}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.horizontalDivider} />
          {/* Row 5: Valid Government Issued ID, Business License */}
          <div className={styles.infoGrid}>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <CreditCard />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>
                  Valid Government Issued ID
                </span>
                <div className={styles.infoValue}>
                  <div
                    className={styles.preview}
                    onClick={() =>
                      setPreviewFile({
                        key: "Govt ID",
                        url: profileData?.gov_id_url,
                      })
                    }
                  >
                    <FaEye />
                  </div>
                  {/* <img
                    src={profileData?.gov_id_url}
                    alt="Govt ID"
                    className={styles.docImage}
                  /> */}
                </div>
              </div>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>
                <FileText />
              </span>
              <div className={styles.infoCol}>
                <span className={styles.infoLabel}>Business License</span>
                <div className={styles.infoValue}>
                  <div
                    className={styles.preview}
                    onClick={() =>
                      setPreviewFile({
                        key: "Business License",
                        url: profileData?.biz_license_url,
                      })
                    }
                  >
                    <FaEye />
                  </div>
                  {/* <img
                    src={profileData?.biz_license_url}
                    alt="Business License"
                    className={styles.docImage}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPopup
        isOpen={previewFile.key}
        onClose={() =>
          setPreviewFile({
            key: "",
            url: "",
          })
        }
      >
        <FilePreviewer url={previewFile.url} />
      </ModalPopup>
    </div>
  );
};

export default UserDetails;
